import { isBrowser } from 'react-device-detect'

import Cookies from 'js-cookie'

// Window.ga is declared globally as `any` by @dfds-frontend/tracking; narrow it here at the usage site.
type GaTracker = { get: (field: string) => string }
type Ga = { getAll: () => GaTracker[] }

const getGaClientId = (): string | undefined => {
  if (isBrowser) {
    try {
      const tracker = (window?.ga as Ga).getAll()[0]
      const clientId = tracker.get('clientId')
      return clientId
    } catch {
      const gaCookie = Cookies.get('_ga')?.split('.')
      const clientId = gaCookie && `${gaCookie[2]}.${gaCookie[3]}`
      return clientId
    }
  }
}

export default getGaClientId
